// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".unpaid-dot[data-v-0726d5ec]{display:inline-block;width:6px;height:6px;padding:0;line-height:6px;overflow:hidden;vertical-align:middle}", ""]);
// Exports
module.exports = exports;
